var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSandWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 3\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.4%",
    y: "-9.4%",
    width: "118.8%",
    height: "118.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.4285714,5.71428572 C12.6857143,5.71428572 13.7142857,6.74285716 13.7142857,8 C13.7142857,9.25714284 12.6857143,10.2857143 11.4285714,10.2857143 L11.4285714,12.5714286 C13.9428572,12.5714286 16,10.5142857 16,8 C16,5.48571428 13.9428572,3.42857144 11.4285714,3.42857144 C8.91428572,3.42857144 6.85714284,5.48571428 6.85714284,8 L9.14285716,8 C9.14285716,6.74285716 10.1714286,5.71428572 11.4285714,5.71428572 L11.4285714,5.71428572 Z M4.45714284,4.57142856 L2.28571428,4.57142856 L2.28571428,6.85714284 L4.45714284,6.85714284 L4.45714284,4.57142856 L4.45714284,4.57142856 Z M27.3142857,1.14285716 L25.1428572,1.14285716 L25.1428572,3.42857144 L27.3142857,3.42857144 L27.3142857,1.14285716 Z M20.4571428,10.2857143 L18.2857143,10.2857143 L18.2857143,12.5714286 L20.4571428,12.5714286 L20.4571428,10.2857143 L20.4571428,10.2857143 Z M11.4285714,10.2857143 L0,10.2857143 L0,12.5714286 L11.4285714,12.5714286 L11.4285714,10.2857143 Z M24,17.1428572 C27.2,17.1428572 29.7142857,14.6285714 29.7142857,11.4285714 C29.7142857,8.22857144 27.2,5.71428572 24,5.71428572 C22.6285714,5.71428572 21.2571428,6.17142856 20.2285714,7.08571428 L21.7142857,8.8 C22.4,8.34285716 23.2,8 24,8 C25.9428572,8 27.4285714,9.48571428 27.4285714,11.4285714 C27.4285714,13.3714286 25.9428572,14.8571429 24,14.8571428 L0.685714281,14.8571428 L0.685714281,17.1428572 L24,17.1428572 L24,17.1428572 Z M26.2857143,19.4285714 L9.6,19.4285714 L9.6,21.7142857 L26.2857143,21.7142857 C28.2285714,21.7142857 29.7142857,23.2 29.7142857,25.1428572 C29.7142857,27.0857143 28.2285714,28.5714286 26.2857143,28.5714286 C24.3428571,28.5714285 22.8571428,27.0857143 22.8571428,25.1428572 L20.5714286,25.1428572 C20.5714286,28.3428572 23.0857143,30.8571428 26.2857143,30.8571428 C29.4857143,30.8571428 32,28.3428571 32,25.1428572 C32,21.9428572 29.4857143,19.4285714 26.2857143,19.4285714 L26.2857143,19.4285714 Z M10.2857143,28.5714286 L12.4571428,28.5714286 L12.4571428,26.2857143 L10.2857143,26.2857143 L10.2857143,28.5714286 Z M4.57142856,21.7142857 L6.74285716,21.7142857 L6.74285716,19.4285714 L4.57142856,19.4285714 L4.57142856,21.7142857 L4.57142856,21.7142857 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.9%",
    y: "-16.8%",
    width: "143.8%",
    height: "147.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE1",
    transform: "translate(-345.000000, -1232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD",
    transform: "translate(365.000000, 1244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F25643",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6C99\\u5C18",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62",
    opacity: 0
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSandWarning);
export default __webpack_public_path__ + "static/media/ico_sand_warning.6a4d3dce0c5820c6f5df2bebfbb13f88.svg";
export { ForwardRef as ReactComponent };